module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"purchased_at":"{0}の購入","best_review_reward":"優秀レビューに選ばれると最大{0}支給！"}}')
  delete Component.options._Ctor
}
